module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_kimono-db10ad257c461e2999ff647e63e86edb.jpg";